var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var defaultMessages = require('../../i18n/messages/default');
var AppConstants = require('../../constants/AppConstants');
var Footer = require('../Footer/Footer.js');
var Header = require('../Header/Header.js');
var UrlUtils = require('../../utils/urlUtils');
var createReactClass = require('create-react-class');
var PageCase = require('../PageCase/PageCase.js');
var SignOut = createReactClass({
  displayName: 'SignedOut',

  getInitialState() {
    return {
      localeId: this.props.localeId
    };
  },

  componentDidMount: function () {
    console.log('componentDidMount called');
    this._iFrameOnLoad()
  },

  _redirectToPostLogoutUri: function () {
    console.log('Page load event triggered');
    let redirectUri = this.postLogoutRedirectUri();
    if (redirectUri) {
      console.log('Redirecting to ' + redirectUri);
      window.location.href = redirectUri;
    }
  },

  _iFrameOnLoad: function () {
    console.log('_iFrameOnLoad called');
    { setTimeout(this._redirectToPostLogoutUri, 1500) }
  },

  onLocalChange(localeId) {
    this.setState({ localeId: localeId });
  },

  renderFooter: function () {
    return (
      <IntlProvider locale={this.state.localeId}
        messages={this.props.translations}>
        <Footer {...this.props} locale={
          this.state.localeId
        } onLocalChange={this.onLocalChange} />
      </IntlProvider>
    )
  },

  postLogoutRedirectUri: function () {
    if (this.props.postLogoutRedirectUri) {
      console.log('postLogoutRedirectUri ----', this.props.postLogoutRedirectUri);
      if (this.props.state) {
        if (this.props.postLogoutRedirectUri.indexOf('?') != -1) {
          return (this.props.postLogoutRedirectUri + '&' + AppConstants.UrlParams.STATE + '=' + this.props.state);
        }
        else {
          return (this.props.postLogoutRedirectUri + '?' + AppConstants.UrlParams.STATE + '=' + this.props.state);
        }
      }
      else {
        return this.props.postLogoutRedirectUri;
      }
    }
  },

  renderAnchorTag: function () {
    let redirectUri = this.postLogoutRedirectUri();
    if (redirectUri) {
      return (
        <div >
          {this.props.intl.formatMessage(defaultMessages['signedOutMsg2'])} <a href={redirectUri}>{this.props.intl.formatMessage(defaultMessages['signedOutMsg3'])}</a> {this.props.intl.formatMessage(defaultMessages['signedOutMsg4'])}
        </div>
        //Click <a className='PostLogoutRedirectUri' href={redirectUri}>here</a> to return to the {this.props.clientId} application.
      )
    }
  },

  renderIframe: function () {
      var clientLogoutUris = window.WebConstants.clientLogoutUri.split('|')
      console.log('clientLogoutUris: ' + clientLogoutUris)
      let clientLogoutIframes = clientLogoutUris.map(function (logoutUri) {
        return <iframe className='endsessioniframe' src={logoutUri}> </iframe>;
      })
      return (
        <div style={{ display: 'none' }}>{clientLogoutIframes}</div>)
  },

  renderLogo: function () {
    return (
      <div className='signedOutLogoContainer'>
        <center>
          <img className="iconResolution img-responsive" id='signed-out' alt='Signed Out' src='assets/images/sign-out.svg' />
        </center>
      </div>
    );
  },
  renderText: function () {
    return (
      <div className="signedOutTextContainer welcomeTitleCustomer">
        <h2 className="centreAligned ">
          <span>{this.props.intl.formatMessage(defaultMessages['signedOut'])}</span>
        </h2>
      </div>
    );
  },
  renderContent: function () {
    return (
      <div className="signedOutPage container">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-sm-2"></div>
          <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12">
            {this.renderLogo()}
            {this.renderText()}
            <div className="signedOutContainer text-center">
              <br />
              <div className="whiteContainer darkblue-text">
                <div className="font20bold">
                  {this.props.intl.formatMessage(defaultMessages['signedOutMsg1'])}
                  <br />
                  {this.renderAnchorTag()}
                </div>
              </div>
              {this.renderIframe()}
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-2"></div>
        </div>
      </div>
    );
  },

  render: function () {
    return (
      <PageCase
        header={<Header />}
        content={this.renderContent()}
        footer={this.renderFooter()}>
      </PageCase>
    );
  }
});

module.exports = injectIntl(SignOut);